var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6697 8.74288C35.2025 9.15684 36.4073 10.3647 36.8147 11.8958C37.5557 14.6745 37.5557 20.4756 37.5557 20.4756C37.5557 20.4756 37.5557 26.2769 36.8147 29.0555C36.4017 30.5923 35.1969 31.8001 33.6697 32.2085C30.8981 32.9513 19.7779 32.9513 19.7779 32.9513C19.7779 32.9513 8.66314 32.9513 5.8859 32.2085C4.35304 31.7945 3.14824 30.5865 2.74098 29.0555C2 26.2769 2 20.4756 2 20.4756C2 20.4756 2 14.6745 2.74098 11.8958C3.1539 10.359 4.35868 9.15116 5.8859 8.74288C8.66314 8 19.7779 8 19.7779 8C19.7779 8 30.8981 8 33.6697 8.74288ZM25.4624 20.4764L16.2256 25.8238V15.1289L25.4624 20.4764Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e2b60e1a108ca4666d92ff764f50fcf2.svg";
export { ForwardRef as ReactComponent };